import React, { useEffect, useState } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { PieChart } from "@mui/x-charts";
import { useTheme } from "@mui/material/styles";
import { asyncGetReport } from "../../../utils/httpRequests";
import { useSelector } from "react-redux";
import moment from "moment";

function LevelUserChart() {
  const theme = useTheme();
  const { token } = useSelector((state: any) => state.auth);
  const [total, setTotal] = useState<number>(0);
  const [data, setData] = useState<
    { id: number; value: number; label: string; color: string }[]
  >([]);

  const getUsers = async () => {
    const resp = await asyncGetReport({
      apiCode: "fos_rpusers",
      token,
      query: {
        tu_ngay: moment("2000-01-01").startOf("days").toISOString(),
        den_ngay: moment().endOf("days").toISOString(),
      },
    });
    if (resp && resp?.status === 200) {
      const reportData = resp?.data || [];
      const total = reportData?.length || 0;
      const levels: { level1: number; level2: number; level3: number } = {
        level1: 0,
        level2: 0,
        level3: 0,
      };
      for (let i = 0; i < reportData.length; i++) {
        const item = reportData[i];
        switch (item.level) {
          case 3:
            levels.level3 += 1;
            break;
          case 2:
            levels.level2 += 1;
            break;
          default:
            levels.level1 += 1;
            break;
        }
      }
      setTotal(total);
      setData([
        {
          id: 1,
          label: "Cấp 1",
          // value: ((levels.level1 || 0) / total) * 100,
          value: levels.level1,
          color: theme.palette.warning.main,
        },
        {
          id: 2,
          label: "Cấp 2",
          // value: ((levels.level2 || 0) / total) * 100,
          value: levels.level2,
          color: theme.palette.success.main,
        },
        {
          id: 3,
          label: "Cấp 3",
          // value: ((levels.level3 || 0) / total) * 100,
          value: levels.level3,
          color: theme.palette.info.main,
        },
      ]);
    } else {
      setData([]);
    }
  };

  useEffect(() => {
    getUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box
      sx={{
        width: "100%",
        backgroundColor: "background.paper",
        borderRadius: "10px",
        px: 2,
        py: 2,
      }}
    >
      <Stack gap={1}>
        <Typography sx={{ textAlign: "center", fontWeight: 600 }}>
          THỐNG KÊ CẤP THÀNH VIÊN
        </Typography>
        <PieChart
          height={250}
          series={[
            {
              data,
              innerRadius: 50,
              paddingAngle: 2,
              cornerRadius: 10,
              arcLabelMinAngle: 30,
              arcLabel: (item) => `${Math.round((item.value * 100) / total)} %`,
            },
          ]}
        />
        <Typography sx={{ textAlign: "left" }}>
          Tổng số: {total || 0}
        </Typography>
      </Stack>
    </Box>
  );
}

export default LevelUserChart;
